import type { ICellRendererParams } from 'ag-grid-community';

import { useCrmUrl } from '@/utils/crm-url';

import { CreatedFertType } from '../types';

export const FertName = ({
  value,
  data,
}: ICellRendererParams<CreatedFertType>) => {
  const baseUrl = useCrmUrl();
  if (!baseUrl) {
    return value;
  }
  const url = new URL('main.aspx', baseUrl);
  url.searchParams.set('etc', '10017');
  url.searchParams.set(
    'extraqs',
    'formid=b8caab64-5324-4038-808b-7fe7fb6a57af',
  );
  url.searchParams.set('id', `{${data?.fertID}}`);
  url.searchParams.set('pagetype', 'entityrecord');

  return (
    <a href={url.toString()} target="_blank" rel="noopener noreferrer">
      {value}
    </a>
  );
};
